import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AssetDepreciationExporter  {
    _originalTypeClassName = "zERP.BO.AssetDepreciationExporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AssetDepreciationExporter.translate = translateService;
}
this.AssetDepreciationExporterKey = null;
this._key = this.AssetDepreciationExporterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _AssetDepreciationExporterKey:any;
get AssetDepreciationExporterKey(): any {
    return this._AssetDepreciationExporterKey;
  }
set AssetDepreciationExporterKey(value: any) {
    this._AssetDepreciationExporterKey = value;
    this._key = value;
  }

static GetCollectionVariables(report: any): any{let vars = new window['Map']();
let assetsChildren = [];
assetsChildren?.add({
Name: "NAME",Description: "Όνομα απόσβεσης",}
);
assetsChildren?.add({
Name: "TYPE",Description: "Τύπος απόσβεσης",}
);
assetsChildren?.add({
Name: "TAX_METHOD",Description: "Μέθοδος απόσβεσης",}
);
assetsChildren?.add({
Name: "ACCOUNTING_METHOD",Description: "Μέθοδος λογιστικής απόσβεσης",}
);
assetsChildren?.add({
Name: "TAX_PERCENT",Description: "Συντελεστής απόσβεσης",}
);
assetsChildren?.add({
Name: "ACCOUNTING_PERCENT",Description: "Συντελεστής λογιστικής απόσβεσης",}
);
assetsChildren?.add({
Name: "LAST_DEPRECIATION",Description: "Τελευταία απόσβεση",}
);
assetsChildren?.add({
Name: "ACQUISITION_VALUE",Description: "Αξία απόκτησης",}
);
assetsChildren?.add({
Name: "TAX_ACCUMULATED_DEPRECIATIONS",Description: "",}
);
assetsChildren?.add({
Name: "ACCOUNTING_ACCUMULATED_DEPRECIATIONS",Description: "",}
);
assetsChildren?.add({
Name: "TAX_NON_DEPRECIATED_VALUE",Description: "",}
);
assetsChildren?.add({
Name: "ACCOUNTING_NON_DEPRECIATED_VALUE",Description: "",}
);
assetsChildren?.add({
Name: "TAX_PREVIOUS_DEPRECIATIONS",Description: "",}
);
assetsChildren?.add({
Name: "ACCOUNTING_PREVIOUS_DEPRECIATIONS",Description: "",}
);
assetsChildren?.add({
Name: "TAX_PERIOD_DEPRECIATIONS",Description: "",}
);
assetsChildren?.add({
Name: "ACCOUNTING_PERIOD_DEPRECIATIONS",Description: "",}
);
vars.set({
Name: "ASSETS",Description: "Αποσβέσεις",IsCollection: true,Children: assetsChildren,}
, Joove.Common.cast(report?.Assets, "System.Collections.List"));
return vars;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AssetDepreciationExporterKey == null || $this.AssetDepreciationExporterKey == 0;
            }


}